import { DatePipe, formatDate } from '@angular/common';
import { Component, LOCALE_ID, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { PaymentService } from 'app/services/payment.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'app-list-bill-payment',
  templateUrl: './list-bill-payment.component.html',
  styleUrls: ['./list-bill-payment.component.css'],
})
export class ListBillPaymentComponent implements OnInit {

  @ViewChild('downloadCellTpl') downloadCellTpl: TemplateRef<any>;
  @ViewChild('actionCellTpl') actionCellTpl: TemplateRef<any>;
  @ViewChild('billCellTpl') billCellTpl: TemplateRef<any>;
  @ViewChild('taxCellTpl') taxCellTpl: TemplateRef<any>;
  @ViewChild('totalCellTpl') totalCellTpl: TemplateRef<any>;
  @ViewChild('expiryDateCellTpl') expiryDateCellTpl: TemplateRef<any>;

  @ViewChild('statusCellTpl') statusCellTpl: TemplateRef<any>;
  @ViewChild('hdrTplWithStatusSearch') hdrTplWithStatusSearch: TemplateRef<any>;
  @ViewChild('hdrTplWithHRUserEmailSearch') hdrTplWithHRUserEmailSearch: TemplateRef<any>;
  @ViewChild('hdrTplWithMonthSearch') hdrTplWithMonthSearch: TemplateRef<any>;



  profiledata: any;
  rows = [];
  dataRows = [];
  columns = [];
  adminUser: Boolean = false;
  submitted = false;
  error = false;
  file_error = false;
  file_message = '';
  success = false;
  dataJSON: any;
  uploadedFile: any;
  base64Content: any;
  monthList = [];
  temp = [];
  excelRows = [];

  defaultSort = [
    {
      prop: 'expiryDate',
      dir: 'desc'
    }
  ];

  header: string[] = [];

  constructor(private router: Router,
    private spinnerService: SpinnerService,
    private commonUtilService: CommonUtilService,
    private authService: AuthService,
    private paymentService: PaymentService,
    private datePipe: DatePipe
  ) {

    this.spinnerService.start();

    this.adminUser = this.authService.isAdmin();

    this.paymentService.getMonthOptionsForBillPayment(this.adminUser).subscribe(dataOptions => {

      this.monthList = dataOptions;

      this.monthList.forEach(function (part, index) {
        this[index] = formatDate(this[index], 'MMMM-yyyy', 'it');
        this[index] = this[index].charAt(0).toUpperCase() + this[index].slice(1);
      }, this.monthList);

      this.getPaymentList();

      this.spinnerService.stop();
    });
  }

  getPaymentList() {
    this.paymentService.getBillPaymentList(this.adminUser).subscribe(data => {
      this.rows = data;
      this.dataRows = data;
      /* console.log(this.rows); */
    });
  }

  ngAfterViewInit(): void {
    this.columns = [
      { name: 'Mese', headerTemplate: this.hdrTplWithMonthSearch, prop: 'month', sortable: true, resizeable: false, width: 150 },
      { name: 'Scadenza', prop: 'expiryDate', cellTemplate: this.expiryDateCellTpl, sortable: true, resizeable: false, width: 110 },
      { name: 'Stato', prop: 'status', headerTemplate: this.hdrTplWithStatusSearch, cellTemplate: this.statusCellTpl, sortable: true, resizeable: false, width: 150 },
      { name: 'Report generati', prop: 'noOfReports', sortable: true, resizeable: false, width: 160 },
      { name: 'Imponibile', prop: 'billAmount', cellTemplate: this.billCellTpl, sortable: true, resizeable: false, width: 120 },
      { name: 'IVA (22%)', prop: 'taxAmount', cellTemplate: this.taxCellTpl, sortable: true, resizeable: false, width: 120 },
      { name: 'Totale', prop: 'totalDue', cellTemplate: this.totalCellTpl, sortable: true, resizeable: false, width: 100 },
      { name: 'Azioni', sortable: false, resizeable: false, width: 250, cellTemplate: this.downloadCellTpl }
    ];

    if (this.adminUser) {
      this.columns.splice(0, 0, { name: 'Utente HR', headerTemplate: this.hdrTplWithHRUserEmailSearch, prop: 'hrUserEmail', sortable: true, resizeable: false, width: 240 });
      this.columns.splice(9, 0, { name: 'Carica Fattura', sortable: true, resizeable: false, width: 180, cellTemplate: this.actionCellTpl });
    }
  }

  ngOnInit() {
    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.INVOICE");
  }

  onFileChange(event, field, extension?) {
    const reader = new FileReader();
    if (event.target.files.length > 0) {
      this.file_error = false;
      this.file_message = '';
      this.uploadedFile = event.target.files[0];
      if (!extension || this.commonUtilService.enabledExtension(this.uploadedFile, extension)) {
        reader.readAsDataURL(this.uploadedFile);
        reader.onload = () => {
          let kb = this.uploadedFile.size / 1024;
          let mb = kb / 1024;
          let sizeParsed = parseFloat(mb.toString());
          if (sizeParsed > CommonUtilService.LIMIT_SIZE_MB) {
            this.file_error = true;
            return;
          }
          this.base64Content = this.commonUtilService.getBase64FromFile(reader.result);

          var dataJSON = {
            fileName: this.uploadedFile.name,
            type: this.uploadedFile.type,
            size: this.uploadedFile.size,
            extension: this.uploadedFile.name.split('.').pop(),
            domain: null,
            userId: null,
            base64: this.base64Content,
            code: null,
            message: null
          }
          this.paymentService.uploadDocument(event.target.id, dataJSON).subscribe(data => { });
        };
      } else {
        this.file_message = CommonUtilService.FILE_BAD_EXTENSION;
        this.file_error = true;
        return;
      }
    }
  }

  getAttachmentFile(name, fileBinary) {
    this.commonUtilService.downloadFile(name, fileBinary, true);
    return false;
  }

  goToBillDetail(id) {
    this.router.navigate(['consumption/bill/detail/' + id]);
  }

  previousStatusFilter = '';
  previousEmailFilter = '';
  previousMonthFilter = '';
  previousYearFilter = '';

  filterRows(event, columnName) {

    var searchVal = event.target.value;

    switch (columnName) {
      case "Stato":
        this.previousStatusFilter = searchVal;
        break;
      case "Utente HR":
        this.previousEmailFilter = searchVal.toLowerCase();
        break;
      case "Mese":
        let splited = event.target.value.split('-');

        this.previousMonthFilter = splited[0];
        this.previousYearFilter = splited[1];
        break;
    }

    this.temp = this.dataRows;
    this.rows = this.temp.filter(row => {

      const isPartialEmail = !this.previousEmailFilter || (row.hrUserEmail && row.hrUserEmail.toLowerCase().indexOf(this.previousEmailFilter) !== -1);
      const isPartialStatusMatch = !this.previousStatusFilter || (row.status && row.status === this.previousStatusFilter);
      const isPartialMonthMatch = !this.previousMonthFilter || (row.month && row.month === this.previousMonthFilter);
      const isPartialYearMatch = !this.previousYearFilter || (row.createDate && new Date(row.createDate).getFullYear().toString() === this.previousYearFilter);

      return isPartialEmail && isPartialStatusMatch && isPartialMonthMatch && isPartialYearMatch;
    });

  }

  changeStatus($event, id) {
    this.spinnerService.start();

    var status = "UN_PAID";
    if ($event.target.checked) {
      status = "PAID";
    }

    this.paymentService.updateBillPaymentStatus(id, status).subscribe(data => {
      this.getPaymentList();
      this.spinnerService.stop();
    });
  }

  exportToExcel(): void {

    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsExcel('Fatture', this.excelRows, "Fatture - HRWE.xlsx");

    this.spinnerService.stop();
  }

  exportToPDF(): void {
    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsPDF(true, this.header, this.excelRows, "Fatture - HRWE.pdf");
    
  }

  exportRows() {

    var formatter = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    });

    if (this.adminUser) {
      this.header = ['Utente HR', 'Mese', 'Scadenza', 'Stato', 'Report generati', 'Imponibile', 'IVA (22%)', 'Totale', 'Azioni'];
      let arr = this.rows.map(row => {
        return {
          'Utente HR': row.hrUserEmail,
          'Mese': row.month,
          'Scadenza': this.datePipe.transform(row.expiryDate, 'dd/MM/yyyy'),
          'Stato': this.commonUtilService.decodePaymentStatus(row.status),
          'Report generati': row.noOfReports,
          'Imponibile': formatter.format(Number(row.billAmount)),
          'IVA (22%)': formatter.format(Number(row.taxAmount)),
          'Totale': formatter.format(Number(row.totalDue)),
          'Azioni': row.noticeFile && row.noticeFile.fileBinary ? row.noticeFile.name : ' '
        }
      });
      return arr;
    } else {
      this.header = ['Mese', 'Scadenza', 'Stato', 'Report generati', 'Imponibile', 'IVA (22%)', 'Totale', 'Azioni'];
      let arr = this.rows.map(row => {
        return {
          'Mese': row.month,
          'Scadenza': this.datePipe.transform(row.expiryDate, 'dd/MM/yyyy'),
          'Stato': this.commonUtilService.decodePaymentStatus(row.status),
          'Report generati': row.noOfReports,
          'Imponibile': formatter.format(Number(row.billAmount)),
          'IVA (22%)': formatter.format(Number(row.taxAmount)),
          'Totale': formatter.format(Number(row.totalDue)),
          'Azioni': row.noticeFile && row.noticeFile.fileBinary ? row.noticeFile.name : ' '
        }
      });
      return arr;
    }
  }

}
